module.exports = __webpack_public_path__ + "/images/logo-af-falabella.69151b1.svg";